/** RegExp for a url validation. */
const urlPattern = /^(http(s)):\/\/.[\w#%+.:=@~-]{2,256}\.[a-z]{2,6}\b([\w#%&+./:=?@~-])*$/u;

/**
 * Validates url.
 * @param url Url string.
 * @returns boolean true if valid url.
 */
export const isValidUrl = (url?: string): boolean | undefined => {
    if (!url) {
        return;
    }
    return urlPattern.test(url);
};

export const getSessionKey = (): string => {
    return window.location.pathname.substring(1);
};
